<script setup lang="ts">
defineProps({
  slots: {
    type: Object,
    required: true
  },
  showAll: {
    type: Boolean,
    default: false
  }
})

const dayMap = {
  monday: 'Lundi',
  tuesday: 'Mardi',
  wednesday: 'Mercredi',
  thursday: 'Jeudi',
  friday: 'Vendredi',
  saturday: 'Samedi',
  sunday: 'Dimanche'
}

function formatDay(day) {
  return dayMap[day] || day
}

function formatTime(timeStr) {
  return timeStr.slice(0, 5)
}
</script>

<template>
  <p v-for="(daySlots, day) in slots" :key="day">
    <template v-if="daySlots.length || showAll">
      <span class="font-medium">{{ formatDay(day) }} : </span>
      <span v-if="daySlots.length">
          <span v-for="slot in daySlots" :key="slot.start" class="mr-2">
            {{ formatTime(slot.start) }}-{{ formatTime(slot.end) }}
          </span>
        </span>
      <span v-else>-</span>
    </template>
  </p>
</template>